import useLocale from '@hooks/useLocale'
import { formatReminderTime } from '@sections/cases/utils/reminders'
import { useCallback } from 'react'

/** Formats a reminder's due time in Jakarta, in the viewer's locale. */
export const useReminderTimeFormat = (): ((dueAt: string) => string) => {
  const { locale } = useLocale()
  return useCallback((dueAt: string) => formatReminderTime(dueAt, locale), [locale])
}

export default useReminderTimeFormat
